import Article from './Article';
import CommunityArticles from './CommunityArticles';
import ArticlePreviewPage from "./ArticlePreviewPage";

const ArticleConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingQuill',

      config: {
        header: {
          display: true
        },

        footer: {
          display: true
        }
      },
    },
  },

  auth: null, //Anyone can access regardless of logged in status

  routes: [
    {
      path: 'article/:id',
      element: <Article />,
    },
    {
      path: 'articlepreview/:id',
      element: <ArticlePreviewPage />,
    },
    {
      path: 'community-articles',
      element: <CommunityArticles />,
    },
  ],
};

export default ArticleConfig;